import { render, staticRenderFns } from "./QueueItem.vue?vue&type=template&id=633aefee&scoped=true&"
import script from "./QueueItem.vue?vue&type=script&lang=js&"
export * from "./QueueItem.vue?vue&type=script&lang=js&"
import style0 from "./QueueItem.vue?vue&type=style&index=0&id=633aefee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633aefee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('633aefee')) {
      api.createRecord('633aefee', component.options)
    } else {
      api.reload('633aefee', component.options)
    }
    module.hot.accept("./QueueItem.vue?vue&type=template&id=633aefee&scoped=true&", function () {
      api.rerender('633aefee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/items/QueueItem.vue"
export default component.exports